export default __webpack_public_path__ + "static/media/mouseonly.e2fc6cf4.png";